
import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceManager from "@/views/系统管理/service/DZServiceManager";
import nyMessageToast from "@/utils/NYMessageToast";
import AddMenuDTO from "@/views/系统管理/model/AddMenuDTO";
import store from "@/store";

@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    serve = new DZServiceManager();

    is_dialog_show = false;

    addMenu = new AddMenuDTO();

    sign = 'add';

    dialog_close(){
        this.is_dialog_show = false
    }

    created() {
        console.log(store.state.user)
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    action_list_data(){
        this.serve.net_get_menu()
    }

    handle_add(){
        let arr = this.selections
        if(arr.length == 0 || arr.length > 1){
            nyMessageToast.warning('请选择一个菜单');
            return
        }
        if(arr[0].menuType == 'B'){
            nyMessageToast.warning('请选择类型为"菜单"项');
            return;
        }
        let obj = arr[0]
        this.addMenu = new AddMenuDTO();
        this.addMenu.menuType = 'B'
        this.addMenu.pid = obj.id
        this.sign = 'add'
        this.is_dialog_show = true
    }
    handle_edit(row){
        this.addMenu = new AddMenuDTO();
        this.addMenu.menuType = 'B'
        this.addMenu.id = row.id
        this.addMenu.pid = row.pid
        this.addMenu.name = row.name
        this.addMenu.perms = row.perms
        this.sign = 'edit'
        this.is_dialog_show = true
    }

    handle_submit(){
        if(this.sign == 'add'){
            this.serve.net_add_menu(this.addMenu,this.action_list_data)
        }else if(this.sign == 'edit'){
            this.serve.net_edit_menu(this.addMenu,this.action_list_data)
        }
        this.dialog_close()
    }

    selections = []
    handleSelectionChange(val) {
        this.selections = val;
    }

    bindMenuType(n){
        if(n == 'C') return '菜单'
        else if( n == 'B') return '按钮'
        else return n;
    }
}
